export const suglasnost_dopunski= {
    templateId: 233,
    category: 3,
    templateTitle: 'Suglasnost - dopunski rad',
    templateDescription: `<p>Radnik koji namjerava zasnovati radni odnos u dopunskom radu dužan je prethodno ishoditi suglasnost trenutnog poslodavca radnika.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Radnik koji radi u punom radnom vremenu može sklopiti ugovor o radu s drugim poslodavcem, pod uvjetima određenim Zakonom o radu.</p>
    <p>Ipak, za dopunski rad postoje određena zakonska ograničenja:</p>
    <li> tjedno ograničenje - može trajati najviše do 8 sati tjedno,</li>
    <li> godišnje ograničenje - može trajati najviše do 180 sati godišnje.</li>
    <br>
    <p>Dodatno se ističe da je moguć samo dopunski rad radnika koji radi u punom radnom vremenu - 40 sati tjedno, bez obzira radi li u punom radnom vremenu kod jednog poslodavca ili ukupno kod svih poslodavaca.</p>
    <p>Nužna zakonska pretpostavka za sklapanje ugovora o dopunskom radu s drugim poslodavcem je izdavanje suglasnosti za takav rad od strane poslodav(a)ca kod kojeg radnik radi na temelju ugovora o radu na puno ili nepuno radno vrijeme.    </p>
    <p>Ukoliko radnik ima više poslodavaca kod kojih kumulativno radi u punom radnom vremenu od 40 sati tjedno, potrebno je da svi poslodavci s kojima radnik već prethodno ima sklopljen ugovor o radu daju pisanu suglasnost, bez obzira u kojem radnom vremenu radi kod njih i bez obzira da li je u radnom odnosu na određeno ili neodređeno vrijeme.</p>
    <p>Također, poslodavac koji je dao radniku suglasnost za dopunski rad može tu suglasnost „povući“, a ne mora je niti dati.</p>
    <p>U praksi se ugovor o dopunskom radu sklapa na određeno vrijeme, no nema zakonske zapreke da se ugovor o dopunskom radu ne sklopi i na neodređeno vrijeme. </p>
    <p>Primjer ugovora o dopunskom radu uz primjenu odredbi Zakona o radu možete pogledati <a class="local-link" href="/contract?template=5.2">ovdje</a>, dok primjerak ugovora o dopunskom radu uz primjenu Pravilnika o radu možete pogledati <a class="local-link" href="/contract?template=5.3">ovdje</a>. </p>


    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o radu.</p>
  `,
  sides: [
    {
      prefix: 'Na temelju Zakona o radu,',
      signature: 'Za Poslodavca:',
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      suffix: " (u daljnjem tekstu: Poslodavac),",
    }
  ],

  headline: 'daje sljedeću',
  title: 'SUGLASNOST ZA DOPUNSKI RAD',

  noArticleNumbers: true,

  articles: [

    {
        title: '',
        mandatory: true,
        statements: [
          {
            type: 'input',
            mandatory: true,
            editable: false,
            parts: [
                { type: 'text', content: 'Radnik' },
                { type: 'input', value: '', required: true, placeholder: "Ime i prezime"},
                { type: "text", content: ","},
                { type: 'text', content: 'iz',},
                { type: 'input', value: '', required: true, placeholder: "Mjesto"},
                { type: 'text', content: ',' },
                { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj"},
                { type: "text", content: "," },
                { type: 'text', content: 'OIB:' },
                { type: "input",  required: true,},
                { type: 'text', content: ', (u daljnjem tekstu: Radnik),'},
                { type: 'text', content: 'zaposlen je kod Poslodavca na radnom mjestu' },
                { type: 'input', value: '', required: true, placeholder: "Naziv radnog mjesta"},
                { type: "text", content: "," },
                {type: 'text', content: 'u'},
                {type: 'input', value: '', required: true, help: "Upisati naznaku da li je radnik zaposlen u punom ili nepunom radnom vremenu."  },
            {type: 'text', content: ', na temelju Ugovora o radu na'},
            {type: 'input', value: '', required: true,  help: "Upisati naznaku da li je radnik zaposlen na određeno ili neodređeno vrijeme."  },
            {type: 'text', content: 'vrijeme.'},
            ]
          }]
      },
      {
        title: '',
        mandatory: true,
        statements: [
          {
            type: 'input',
            mandatory: true,
            editable: false,
            parts: [
                { type: 'text', content: 'Suglasnost iz ove Odluke daje se Radniku za obavljanje dopunskog rada kod poslodavca' },
                { type: 'input', value: '', required: true,  help: "Upisati podatke poslodavca kod kojega će radnik raditi u dopunskom radu."  },
  
            ]
          }]
      },
      {
        title: "",
        mandatory: true,
        statements: [
          {
            type: "choice",
            mandatory: true,
            editable: false,
            choices: [
              {
                parts: [
                { type: 'text', content: 'Radniku se daje suglasnost za sklapanje ugovora o dopunskom radu na određeno vrijeme', help: "Ovaj odabir ispunjavate ukoliko želite ograničiti trajanje dopunskog rada najkasnije do određenog dana."},
            {type: 'text', content: ', u trajanju radnog vremena od'},
            {type: 'input', value: '', required: true, help: "Potrebno upisati broj sati tjednog rada. Dopunski rad ne smije trajati duže od 8 sati tjedno i duže od 180 sati godišnje."},
            {type: 'text', content: 'sati'},
            {type: 'text', content: ', počevši od '},
            {type: 'input', value: '', required: true, help: "Potrebno upisati datum početka rada u dopunskom radu."  },
            {type: 'text', content: ', a najkasnije do '},
            {type: 'input', value: '', required: true, help: "Ukoliko želite ograničiti trajanje dopunskog rada na određeno vrijeme, potrebno je upisati datum do kojega radnik može raditi u dopunskom radu odnosno u protivnom upisati ,do prestanka potrebe' i sl.."  },
          ]
        },
        {
              parts: [
                { type: 'text', content: 'Radniku se daje suglasnost za sklapanje ugovora o dopunskom radu na neodređeno vrijeme', help: "Ovaj odabir ispunjavate ukoliko ne želite ograničiti trajanje dopunskog rada najkasnije do određenog dana. Ipak, poslodavac suglasnost uvijek može povući."  },
                {type: 'text', content: ', u trajanju radnog vremena od'},
                {type: 'input', value: '', required: true, help: "Potrebno upisati broj sati tjednog rada. Dopunski rad ne smije trajati duže od 8 sati tjedno i duže od 180 sati godišnje."  },
                {type: 'text', content: 'sati'},
                {type: 'text', content: ', a počevši od '},
                {type: 'input', value: '', required: true, help: "Potrebno upisati datum početka rada u dopunskom radu."  },
              ]
            }],
        },
      ]
    },
    {
      title: '',
      mandatory: true,
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          content: `Dopunski rad iz ove Odluke, Radnik može obavljati kod poslodavca naznačenog u ovoj Odluci, no isključivo nakon završetka radnog vremena kod Poslodavca.`,
        }]
    },
    {
      title: '------------------------------------------------------Obrazloženje------------------------------------------------------',
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: 'input',
          mandatory: true,
          editable: false,
          parts: [
              { type: 'text', content: 'Radnik je dana' },
              { type: 'input', value: '', required: true, },
              { type: 'text', content: 'godine zatražio od Poslodavca prethodnu suglasnost za obavljanje dopunskog rada kod ' },
              { type: 'input', value: '', required: true, help: "Upisati podatke poslodavca kod kojega će radnik raditi u dopunskom radu."  },
          ]
        }]
    },
    {
      title: '',
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          content: `Suglasnost se daje Radniku za obavljanje poslova dopunskog rada izvan radnog vremena koje obavlja kod Poslodavca.`,
        }]
    },
    {
        title: '',
        mandatory: true,
        dummy: true,
        statements: [
          {
            type: 'text',
            mandatory: true,
            editable: true,
            content: `Sukladno navedenom, odlučeno je kao i izreci ove Odluke. `,
          }]
      },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true,
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 3,  // signature
      statements: [],
    },
    {
      static: true,
      mandatory: false,
      type: 4, 
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska evidencija ',
          help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
        }
      ]
    },
  ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/233_suglasnost_dopunski.ts